import React, { useEffect } from 'react'
import OwlCarousel from 'react-owl-carousel';
import AOS from "aos";
import "aos/dist/aos.css";
import { useDispatch, useSelector } from 'react-redux'
import { getTestimonialData } from '../../../Redux/action/MasterAction';
import Aos from 'aos';
const host = process.env.REACT_APP_API_SERVER
const Testimonial = () => {

    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(getTestimonialData())
    }, []);

    const {
        loadingTestimonialDataListApi,
        TestimonialDataListApiData,
        TestimonialDataListApiError,
    } = useSelector(state => state?.MasterReducer);

    const options = {
        loop: TestimonialDataListApiData?.length > 1,
        margin: 10,
        nav: true,
        dots: false,
        autoplay: true, // Enable autoplay
        autoplayTimeout: 2000, // Set the time (in milliseconds) for each slide
        responsive: {
            0: {
                items: 1
            },
            600: {
                items: 3
            },
            1000: {
                items: 4
            }
        }
    }

    useEffect(function () {
        Aos.init({ duration: 1000 });
    }, []);

    return (
        <section className="testimonial-two student-say-about testimonial-section">
            <div className="container" data-aos="fade-up">
                <div
                    className="section-header h-three"

                >
                    <h2 />
                    <div className="heading">
                        <span className="ruby section-badge">
                            
                            TESTIMONIALS &amp; REVIEWS 
                            
                        </span>
                    </div>
                    <div className="heading-bar">
                        <span />
                        <span />
                    </div>
                </div>
                {/* <div class="owl-carousel"> */}
                <OwlCarousel className='owl-theme section' loop margin={20} autoplay {...options}>
                    {/* <div className="row justify-content-center owl-carousel"> */}
                    {TestimonialDataListApiData?.map((data) => (
                        <div
                            className="col-lg-4 col-md-6 w-100"

                            key={data?.id}
                        >
                            <div className="customer-review p-2">
                                <div className="review-card">
                                    <div className="rating">
                                        {Array.from({ length: 5 }, (_, index) => {
                                            if (index < Math.floor(data?.rating || 0)) {
                                                return <i key={index} className="fas fa-star filled" />;
                                            } else if (index < data?.rating) {
                                                return <i key={index} className="fas fa-star-half-alt filled" />;
                                            } else {
                                                return <i key={index} className="fas fa-star" />;
                                            }
                                        })}

                                    </div>
                                    <p>
                                        “{data?.review}“
                                    </p>
                                    <div className="customer">
                                        <img src={`${host}${data?.image}`} alt="" />
                                    </div>
                                </div>
                                <div className="cus-name">
                                    <a href="javascript:void(0);">{data?.name}</a>
                                    <span>{data?.designation}</span>
                                </div>
                            </div>
                        </div>
                    ))}
                    {/* </div> */}
                </OwlCarousel>
                {/* </div> */}
            </div>
        </section>
    )
}

export default Testimonial